module.exports = __webpack_public_path__ + "static/media/Harry F. Byrd - 1960.651d4fff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Harry F. Byrd - 1960.jpg
// module id = 483
// module chunks = 0